
    import _ from 'underscore';
    import {
        computed, defineComponent, onMounted, PropType, ref, toRefs, unref,
    } from 'vue';

    import ImagesSlider from '@ve/components/images-slider/common/ImagesSlider.vue';
    import { ImagesSliderPhoto, ImagesSliderVideo } from '@ve/components/images-slider/common/types';
    import imageProxy from '@/js/common/Domain/Service/imageProxy';
    import { useMutations } from 'vuex-composition-helpers';
    import { NAMESPACE as HOTEL_PAGE_GALLERY_STORE } from '@ve/pages/hotel/store/HotelPageGalleryStore';
    import { IHotelPageGalleryStoreMutations } from '@ve/pages/hotel/store/types';

    const AVAILABLE_IMAGES_SIZES = [
        [940, 705, 1240],
        [640, 480],
    ];

    export default defineComponent({
        name: 'images-slider-hotel',
        props: {
            images: {
                type: Array as PropType<ImagesSliderPhoto[]>,
                required: false,
                default: [],
            },
            videos: {
                type: Array as PropType<ImagesSliderVideo[]>,
                required: false,
                default: [],
            },
            video: {
                type: Object as PropType<ImagesSliderVideo | null>,
                default: null,
            },
            isVisibleThumbs: {
                type: Boolean,
                default: true,
            },
        },
        components: {
            ImagesSlider,
        },
        setup(props) {
            const {
                images,
            } = toRefs(props);

            const { setIsWatchGalleryUntilTheEnd, setIsClickedOnThumb, addIndexOfWatchPhoto } = useMutations<IHotelPageGalleryStoreMutations>(HOTEL_PAGE_GALLERY_STORE, ['setIsWatchGalleryUntilTheEnd', 'setIsClickedOnThumb', 'addIndexOfWatchPhoto']);

            const generateSrcSet = (src: string) => _.map(AVAILABLE_IMAGES_SIZES, ([width, height, screenWidth]) => `${
                imageProxy(src, {
                    width,
                    height,
                })} ${screenWidth ? `${screenWidth}w` : ''}`).join(', ');

            const thumbs = computed(() => unref(images).map((image) => ({
                alt: image.alt,
                src: imageProxy(image.src, {
                    width: 92,
                    height: 69,
                }),
            })));

            const sizedImages = computed(() => unref(images).map((image) => ({
                alt: image.alt,
                src: imageProxy(image.src, {
                    width: 640,
                    height: 480,
                }),
                srcset: generateSrcSet(image.src),
            })));

            const selectedIndex = ref(0);

            const slideChangeHandler = (index: number) => {
                addIndexOfWatchPhoto(index);
                selectedIndex.value = index;
            };

            onMounted(() => addIndexOfWatchPhoto(0));

            return {
                thumbs,
                sizedImages,
                selectedIndex,
                slideChangeHandler,
                setIsWatchGalleryUntilTheEnd,
                setIsClickedOnThumb,
            };
        },
    });
